export default () => {
  const mobileDropdownItems = document.querySelectorAll('.header__mobile-menu-item--dropdown');

  mobileDropdownItems.forEach((item) => {
    const link = item.querySelector(':scope > a');

    if (!link) {
      return;
    }

    link.addEventListener('click', (event) => {
      event.preventDefault();
      item.classList.toggle('is-active');
    });
  });
};
